import {
    ADD_ORDER_START,
    ADD_ORDER_SUCCESS,
    ADD_ORDER_ERROR
} from '../../constants';
import { change } from 'redux-form';
import showToaster from "../../helpers/toastrMessgaes/showToaster"
import { setLoaderComplete, setLoaderStart } from '../loader/loader';
import { addOrderWhole as mutation, uploadReviewImageMutation } from '../../lib/graphql';
import { readGuestMeta, clearGuestMeta, writeBookingDraft, readGuestPhotos, clearGuestPhotos } from '../../helpers/bookingDraft';
import history from '../../history';


export function addOrderAction(ordersData) {
    return async (dispatch, getState, { client }) => {
        try {
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch({
                type: ADD_ORDER_START,
            });
            dispatch(setLoaderStart('orderLoading'));
            const cartList = ordersData?.length > 0 && JSON.stringify(ordersData)
            const { data } = await client.mutate({
                mutation,
                variables: {
                    cartList
                }
            })
            if (data?.addOrderWhole?.status === 200) {
                const newOrderId = data?.addOrderWhole?.result?.id;
                // GUEST → AUTH carry-over (approach B): apply what the guest chose on /order-review
                // (stashed in guest meta) onto the just-created order — keyed by the REAL orderId, BEFORE
                // /order mounts, so OrderDetails + QuestionnaireFields rehydrate from the draft and the
                // booking modals read the schedule / preferred pro from redux. No-op for a normal
                // logged-in booking (no guest meta present).
                try {
                    const gmeta = readGuestMeta();
                    if (gmeta && newOrderId) {
                        writeBookingDraft(newOrderId, {
                            description: gmeta.description || undefined,
                            questionnaire: gmeta.questionnaire || undefined,
                        });
                        if (gmeta.scheduledAt != null) dispatch(change('OrderDetails', 'scheduledAt', gmeta.scheduledAt));
                        if (gmeta.estimatedHours != null) dispatch(change('OrderDetails', 'estimatedHours', gmeta.estimatedHours));
                        if (gmeta.preferredPartnerId) dispatch(change('PreferredProviderForm', 'preferredPartnerId', gmeta.preferredPartnerId));
                        clearGuestMeta();
                    }
                } catch (e) { /* never block order creation on carry-over */ }
                // Link any photos the guest uploaded logged-out (fileNames only) to the new order.
                try {
                    const guestPhotos = readGuestPhotos();
                    if (guestPhotos.length > 0) {
                        await Promise.all(guestPhotos.map((picture) =>
                            client.mutate({ mutation: uploadReviewImageMutation, variables: { orderId: newOrderId, picture } }).catch(() => null)
                        ));
                        clearGuestPhotos();
                    }
                } catch (e) { /* photos are optional — never block the order */ }
                dispatch(setLoaderComplete('orderLoading'));
                history.push(`/order/${newOrderId}`);
                dispatch({
                    type: ADD_ORDER_SUCCESS,
                });
            } else {
                dispatch(setLoaderComplete('orderLoading'));
                let errorMessage = data?.addOrderWhole?.errorMessage
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage })
                dispatch({ type: ADD_ORDER_ERROR });
            }
        } catch (error) {
            dispatch({
                type: ADD_ORDER_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}



